export const allKeys = [
  { name: "nummer", weight: 30 },
  { name: "kontoer.kontonummer", weight: 30 },
  { name: "navn", weight: 25 },
  { name: "kontoer.navn", weight: 20 },
  { name: "kontoer.kunForOrgForm", weight: 20 },
  { name: "kontoer.metaData.hjelpetekstForFuse", weight: 15 },
  { name: "kontoer.metaData.sokeordForFuse", weight: 1000 },
]
